import { useBetslipLsStore } from '../../storeLs';

export const getBetslipKey = () => {
  const currentBetslip = useBetslipLsStore.getState().basketNumber;
  if (currentBetslip > 0) {
    return `betslip_${currentBetslip}`;
  }
  return 'betslip';
};
